.ActionsCell {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;
}

.ClientIdCell {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.Alert {
  position: absolute;
  left: 1rem;
  right: 1rem;
  margin-top: -3rem;
  z-index: 1;
}
